
import DonateTypeSelectScreen from "./DonateTypeSelectScreen";
import DonateClubsLIstingScreen from "./DonateClubsListingScreen";
import DonateNotificationFailScreen from "./DonateNotificationFailScreen";
import DonateNotificationConfirmScreen from "./DonateNotificationConfirmScreen";
import DonateCharitiesListingScreen from "./DonateCharitiesListingScreen";
import DonateDetailScreen from "./DonateDetailsScreen";
import { createStackNavigator } from "@react-navigation/stack";
import React from "react";

const Stack = createStackNavigator();

export default function donateNavigationStack() {
    return (
        <>
            <Stack.Screen
                  name="DonateTypeSelectScreen"
                  component={DonateTypeSelectScreen}
                  options={{ title: null, headerShown: false }}
                />
                <Stack.Screen
                  name="DonateCharitiesListing"
                  component={DonateCharitiesListingScreen}
                  options={{ title: null, headerShown: false }}
                />
                <Stack.Screen
                  name="DonateClubsListing"
                  component={DonateClubsLIstingScreen}
                  options={{ title: null, headerShown: false }}
                />
                <Stack.Screen
                  name="DonateDetail"
                  component={DonateDetailScreen}
                  options={{ title: null, headerShown: false, headerRight: () => <MainMenuButton /> }}
                />
                <Stack.Screen
                  name="DonateNotificationConfirm"
                  component={DonateNotificationConfirmScreen}
                  options={{ headerShown: false }}
                />
                <Stack.Screen
                  name="DonateNotificationFail"
                  component={DonateNotificationFailScreen}
                  options={{ headerShown: false }}
                />
        </>
    )
}